export default __webpack_public_path__ + "static/media/logo-welcome.ed5142d9.webp";